// extracted by mini-css-extract-plugin
export default {"page__title":"AccountPage_page__title__2-9qE","form":"AccountPage_form__47zsi","form__fields":"AccountPage_form__fields__2vVyo","form__button":"AccountPage_form__button__QRhi9"};